// extracted by mini-css-extract-plugin
export default {"componentWrapper":"OrderHeader_componentWrapper__+ggnO","label":"OrderHeader_label__jcZ8-","title":"OrderHeader_title__6rnvG"};